import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { UppGridConfiguration } from '@unpispas/upp-wdgt';

import { languageSupport, languageService } from '@unpispas/upp-base';
import { stateService } from '@unpispas/upp-base';
import { configService, Configuration } from '@unpispas/upp-base';

import { logsService } from '@unpispas/upp-base';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'upp-base-tester',
    templateUrl: 'test-base.html',
    styleUrls: [
        'test-base.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class uppBaseTesterComponent extends languageSupport implements OnInit, OnDestroy {

    constructor(private lang: languageService, private change: ChangeDetectorRef, private title: Title, private state: stateService, private config: configService, private logs: logsService) {
        super(lang, change);
        this.title.setTitle('Base Tester');
    }

    ngOnInit(): void {
        this.state.IsReady = true;
    }

    ngOnDestroy(): void {
        super.OnDestroy();
    }

    public dropdownOpen = false;
    OnDropdown(){
        this.dropdownOpen = !this.dropdownOpen;
    }

    public get _scrolltest(){
        const _items = [];

        for (let i=1; i < 10; i++){
            _items.push('CONTENIDO ' + i);
        }

        return _items;
    }

    private _gridconfig: Configuration | null = null;
    private get gridconfig(){
        if (!this._gridconfig){
            this._gridconfig = this.config.getConfiguration('TEST_GRID')
        }
        return this._gridconfig;
    }

    get GridMode(){
        return this.gridconfig.get(UppGridConfiguration.viewmode);
    }

    OnGridModeChange(event: any){
        this.gridconfig.set('viewmode', event.detail.value);
        this.gridconfig.commit();

        setTimeout(() => {
            this.dropdownOpen = false;
            this.change.markForCheck();
        }, 100);
    }


    public custom: string | null = null;
    public form = new FormGroup({
        example: new FormControl('tiene que poner esto', [
            Validators.required
        ]),
    });

    /****************************/

    private selectedLanguage = 'en'; 

    get currentLanguage(){
        return this.selectedLanguage;
    }

    get availableLanguages(){
        return this.lang.GetLanguages();
    }

    get currentCampaign(){
        if(this.logs.IsActive){
            return this.logs.Campaign;
        }

        return null;
    }
    

    changeLanguage(language: string): void {
        this.lang.SetLanguage(language);
        this.selectedLanguage = this.lang.GetLanguage(true);
    }

    async startCampaign() {
        await this.logs.Start('TestCampaign');
        console.log('Logging started!');
        this.change.markForCheck();
    }
    
    async stopCampaign() {
        await this.logs.Stop();
        console.log('Logging stopped!');
        this.change.markForCheck();
    }
    
    logStressTest() {
        for (let i = 0; i < 1000; i++) {
            console.info(`Stress test log #${i}`);
        }
    }
}